var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 8,
  fill: "none",
  stroke: "#000"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  strokeWidth: 1.5,
  d: "m12 1.5-5 5-5-5"
})));
export default SvgArrow;